export default __webpack_public_path__ + "static/media/about.abc7c05f.png";